// Haptic patterns (HANDOVER §8). A PWA only gets on/off vibration; the setting turns them off.
import { useSettings } from '../data/settings'

const PATTERNS = {
  detent: 8,
  drop: 25,
  crack: [15, 30, 15],
  correct: 12,
  wrong: [40, 50, 40],
  slap: 60,
  checkIn: [30, 40, 60],
  toast: 25,
} as const

export type Haptic = keyof typeof PATTERNS

export function buzz(kind: Haptic) {
  if (!useSettings.getState().vibration) return
  try {
    navigator.vibrate?.(PATTERNS[kind] as number | number[])
  } catch {
    // Not allowed (no user gesture yet): ignore.
  }
}
